import React, {useState} from "react";
import {Wrapper, Nav, Map, MapModal} from "./index.styled";

const Commute = () => {
  const [showFullMap, setShowFullMap] = useState(false);

  return (
    <Wrapper>
      <Nav>
        <div>
          <p>ROW DTLA is located in the Arts District with endless access to easy transportation options- major freeways, transit lines, bike paths and ROW DLTA’s shuttle.</p>
        </div>
      </Nav>

      <Map onClick={()=>{setShowFullMap(!showFullMap)}}>
        <img className="center" src="/images/pages/maps/shuttlelMap.jpeg" alt="Row primary map" />
      </Map>
      {showFullMap &&
        <MapModal onClick={() => {
          setShowFullMap(!showFullMap)
        }}>
          <img className="center" src="/images/pages/maps/shuttlelMap.jpeg" alt="Row primary map" />
        </MapModal>
      }
    </Wrapper>
  )
}

export default Commute;
